import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66f6a1c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-actions" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_ActionModal = _resolveComponent("ActionModal")
  const _component_AdditionalDocumentsModal = _resolveComponent("AdditionalDocumentsModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-outline sml ml-2",
      ref: _ctx.buttonRef,
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.buttonClicked()))
    }, [
      _createTextVNode(" Actions "),
      _createElementVNode("i", {
        class: "fal fa-angle-down ml-2 mr-0",
        ref: _ctx.iconRef
      }, null, 512)
    ], 512),
    _createElementVNode("div", {
      id: _ctx.dropdownRef,
      ref: _ctx.dropdownRef,
      class: "dropdown-content"
    }, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuOptions, (o, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            onClick: $event => (_ctx.menuSelected(o)),
            class: _normalizeClass(o.isDisabled ? 'disabled': '')
          }, [
            _createTextVNode(_toDisplayString(o.menuText), 1),
            (o.showIcon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(o.icon)
                }, null, 2))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 256))
      ])
    ], 8, _hoisted_2),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_ActionModal, {
          key: 0,
          practice: _ctx.practice,
          "onUpdate:practice": _cache[1] || (_cache[1] = $event => ((_ctx.practice) = $event)),
          actionType: _ctx.actionType,
          "onUpdate:actionType": _cache[2] || (_cache[2] = $event => ((_ctx.actionType) = $event)),
          onCloseModal: _cache[3] || (_cache[3] = $event => (_ctx.showModal = false)),
          onReloadData: _cache[4] || (_cache[4] = $event => (_ctx.reloadData()))
        }, null, 8, ["practice", "actionType"]))
      : _createCommentVNode("", true),
    (_ctx.showAdditionalDocumentsModal)
      ? (_openBlock(), _createBlock(_component_AdditionalDocumentsModal, {
          key: 1,
          practice: _ctx.practice,
          "onUpdate:practice": _cache[5] || (_cache[5] = $event => ((_ctx.practice) = $event)),
          onClose: _cache[6] || (_cache[6] = $event => (_ctx.showAdditionalDocumentsModal = false)),
          onReloadData: _cache[7] || (_cache[7] = $event => (_ctx.reloadData()))
        }, null, 8, ["practice"]))
      : _createCommentVNode("", true)
  ]))
}